import { render, staticRenderFns } from "./Groupmanagement.vue?vue&type=template&id=0bffdd9e&"
import script from "./Groupmanagement.vue?vue&type=script&lang=js&"
export * from "./Groupmanagement.vue?vue&type=script&lang=js&"
import style0 from "./Groupmanagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports